import React from 'react';

import { TextContentComponent } from '@myriadgenetics/mgh-types';
import TextContent from '../../informational/text-content';

import './index.scss';
import { useTranslation } from 'react-i18next';

type ContactInfoProps = {
  type: 'TEXT_CONTENT';
  compDef: TextContentComponent;
};

export const ContactInfo = (props: ContactInfoProps) => {
  const { t } = useTranslation();
  const components = props.compDef.data.components;
  if (components?.length !== 4) {
    return null;
  }

  // One Medical survey drops the Contact Info heading
  let isOneMed = false;

  if ('contentKey' in components[0]?.data) {
    isOneMed = components[0]?.data?.contentKey === 'results.oneMed.peContactName';
  }

  return (
    <div className={`contact-info ${isOneMed ? 'contact-info__onemed' : ''}`}>
      {!isOneMed && <TextContent compDef={components[0]} className="heading-small--semi-bold color-gray-600" />}
      <a href={`tel:${components[1].type === 'TEXT_CONTENT' && components[1].data.contentKey ? t(components[1].data.contentKey) : ''}`}>
        <TextContent compDef={components[1]} className="heading-medium--semi-bold" />
      </a>
      <div className="availability__wrapper">
        <TextContent compDef={components[2]} className="text-large--regular color-gray-600" />
        <TextContent compDef={components[3]} className="text-large--regular color-gray-600" />
      </div>
    </div>
  );
};

export default ContactInfo;
